// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1Dm3B","footer":"ReportModalFilter_footer__AQ8VF"};